import { ChevronRight } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

const FLOW = [
  { label: "SCANNING", tone: "neutral" },
  { label: "STAY ALERT", tone: "neutral" },
  { label: "EXECUTE THE TRADE", tone: "neutral" },
  { label: "TRADE HOLDING", tone: "neutral" },
  { label: "VALIDATED", tone: "green" },
  { label: "TP1 HIT", tone: "green" },
  { label: "HOLD", tone: "green" },
  { label: "TP2 HIT", tone: "green" },
];

const OUTCOMES = [
  { label: "INVALIDATED", tone: "risk" },
  { label: "STOP LOSS", tone: "risk" },
  { label: "DO NOTHING", tone: "white" },
  { label: "OUTSIDE SESSION — NO TRADE", tone: "dim" },
];

const tones = {
  neutral: "border-line bg-ink text-mist",
  green: "border-neon/50 bg-neon/5 text-neon",
  risk: "border-risk/40 bg-risk/5 text-risk",
  white: "border-line bg-charcoal text-white",
  dim: "border-dashed border-line bg-transparent text-dim",
};

export default function LifecycleV2() {
  return (
    <section id="lifecycle" data-testid="lifecycle-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="04 — The Lifecycle"
          testid="lifecycle-heading"
          title={
            <>
              From opportunity
              <br />
              to <span className="text-neon">outcome.</span>
            </>
          }
          description="Every P.E.E. opportunity moves through a defined lifecycle. Instead of constantly asking “What should I do now?” the trader can understand where the opportunity currently stands within the process."
        />

        <div className="mt-14 flex flex-wrap items-center gap-y-4">
          {FLOW.map((s, i) => (
            <div key={s.label} className="flex items-center">
              <Reveal delay={0.07 * i}>
                <span
                  data-testid={`lifecycle-step-${i}`}
                  className={`inline-block rounded-full border px-4 py-2 font-mono text-[11px] uppercase tracking-[0.14em] ${tones[s.tone]}`}
                >
                  {s.label}
                </span>
              </Reveal>
              {i < FLOW.length - 1 && (
                <ChevronRight size={15} className="mx-2 shrink-0 text-dim" />
              )}
            </div>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-14 border-t border-line pt-8">
            <div className="mb-5 font-mono text-[10px] uppercase tracking-[0.3em] text-dim">
              Alternate outcomes — handled by process
            </div>
            <div className="flex flex-wrap gap-3">
              {OUTCOMES.map((o, i) => (
                <span
                  key={o.label}
                  data-testid={`lifecycle-outcome-${i}`}
                  className={`inline-block rounded-full border px-4 py-2 font-mono text-[11px] uppercase tracking-[0.14em] ${tones[o.tone]}`}
                >
                  {o.label}
                </span>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <h3 className="mt-16 font-display text-2xl font-extrabold uppercase leading-snug tracking-tight text-white sm:text-4xl">
            Not every opportunity
            <br />
            <span className="text-neon">deserves a trade.</span>
          </h3>
        </Reveal>
      </div>
    </section>
  );
}
